
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { StockIn } from "@/models/base";
import Vue from "vue";
import AppEditRow from "./EditRow.vue";
import AppRow from "./RowMobile.vue";

export default Vue.extend({
	props: {
		selectedRow: {
			type: Object as () => StockIn,
		},
		stocks: {
			type: Array as () => StockIn[],
			required: true
		},
		isSaving: Boolean
	},
	methods: {
		cancel() {
			this.$emit("cancel");
		},
		save() {
			this.$emit("save");
		},
		editRow(row:StockIn) {
			this.$emit("edit-row", row);
		},
		addRow(row:StockIn) {
			this.$emit("add-row", row);
		},
		removeRow(row:StockIn) {
			this.$emit("remove-row", row);
		}
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar,
		AppEditRow,
		AppRow
	}
});
